import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { ClientGroupBO, ClientGroupRepositoryBase } from '@skylab-shared/business';
import { EventBusBase } from '@skylab-shared/core';

import { CommandBus, EventBus, L10n, L10nBase, RootContext, RootContextBase, Weaver, WeaverBase } from '@skylab-angular-shared/core';
import { BooleanValueAccessorDirective, ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, FocusByDirective, FormContainerComponent, TextValueAccessorDirective, ToastService, ValidateDirective, ValidationSourceDirective } from '@skylab-angular-shared/ui';

import { FormsModule } from '@angular/forms';
import { ClientGroupRepository } from '@skylab-angular-shared/business';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { ClientGroupModel } from '@skylab-shared/dataModel';
import { DictionaryDialogComponentBase, DictionaryDialogViewModelBase } from '../dictionary-dialog-base';

export interface ClientGroupDialogResult {
    externalId: string;
    version: string;
}

interface ClientGroupDialogViewModel extends DictionaryDialogViewModelBase<ClientGroupBO> {
    wasDefault: boolean;
}
@Component({
    selector: 'skl-client-group-dialog',
    templateUrl: './client-group-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, ValidationSourceDirective, BooleanValueAccessorDirective, FormsModule, ValidateDirective, TextValueAccessorDirective, FocusByDirective, ButtonComponent, TranslatePipe]
})
export class ClientGroupDialogComponent extends DictionaryDialogComponentBase
<
ClientGroupModel,
ClientGroupBO,
ClientGroupRepositoryBase,
ClientGroupDialogViewModel
> {
    public constructor(
        @Inject(ClientGroupRepository) ClientGroupRepositoryBase: ClientGroupRepositoryBase,
        @Inject(L10n) l10n: L10nBase,
        @Inject(Weaver) weaver: WeaverBase,
        @Inject(RootContext) rootContext: RootContextBase,
        @Inject(EventBus) eventBus: EventBusBase,
        toastService: ToastService,
        commandBus: CommandBus,
        dialogService: DialogInsService
        ) {
        super(ClientGroupRepositoryBase, toastService, l10n, weaver, rootContext, commandBus, eventBus, dialogService);
    }

    protected override async prepareViewModelAsync(): Promise<void> {
        await super.prepareViewModelAsync();
        this.viewModel.wasDefault = false;
    }

    protected override async prepareDataAsync(): Promise<void> {
        await super.prepareDataAsync();
        this.viewModel.wasDefault = this.viewModel.bo.model.isDefault;
    }
}
